import React, { useEffect, useState } from 'react'; 
import ListTemplate from '../../../Reusable_Components/ListTemplate';  
import axios from 'axios'; 
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';  

const TaxTypeListDetails = () => { 
  const [taxTypes, setTaxTypes] = useState([]); 

  useEffect(() => { 
    const fetchTaxTypes = async () => { 
      try { 
        const url = `${API_DOMAIN}${API_ROUTES.tax_type}`; 
        const token = localStorage.getItem('token'); 
         
        const response = await axios.get(url, { headers }); 
        setTaxTypes(response.data); 
      } catch (error) { 
        console.error('Error fetching tax types:', error); 
      } 
    }; 

    fetchTaxTypes(); 
  }, []); 

  const columns = [ 
    { label: 'Name', value: 'name' }, 
    { label: 'Code', value: 'code' }, 
    { label: 'Category', value: 'category' }, 
    { label: 'Rate', value: 'rate' }, 
    { label: 'Description', value: 'description' }, 
  ]; 

  const handleViewDetails = (taxTypeId) => { 
    //console.log('View Details', taxTypeId); 
    const encodedId = btoa(taxTypeId); 
    window.location.href = `/tax/type/details/${encodedId}`; 
  }; 

  const handleEditDetails = (taxTypeId) => {
    const encodedId = btoa(taxTypeId); 
        window.location.href = `/tax/type/input/${encodedId}`;
    };

  const actionButtons = [ 
    { label: 'Edit Details', handler: handleEditDetails }, 
  ]; 

  return <ListTemplate columns={columns} data={taxTypes} actionButtons={actionButtons} />; 
}; 

export default TaxTypeListDetails;